module.exports = __webpack_public_path__ + "img/loading-bar.f0b1a6ab.svg";